import { LineConnectedPage } from './LineConnectedPage';
export default LineConnectedPage;
